import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Add from "@mui/icons-material/Add";
import styles from "./LeftNavTeamTab.module.scss";
import { useNavigate, useLocation, generatePath } from "react-router-dom";
import { ROUTES } from "../../../../utils/Constant";
import ProjectService from "../../../../service/ProjectService";
import { useProjectFetcher } from "../../../../utils/ProjectsFetcherHooks";

export const LeftNavTeamTab = (props) => {
  const { t } = useTranslation();
  const { id, name, projects, canAddProject } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const addProject = useCallback(async () => {
    const bodyData = {
      name: `${t("project.project")} (${projects.length + 1})`,
      teamId: id,
    };

    const res = await ProjectService.createProject(bodyData);

    return res.data.data.id;
  }, [id, projects.length, t]);

  const onContainerClick = useCallback(() => {
    navigate(generatePath(ROUTES.TEAM_PROJECTS, { teamId: id }));
  }, [navigate, id]);

  const { fetchMyProjectsAndUpdateStore } = useProjectFetcher();

  const onAddProjectClick = useCallback(
    async (e) => {
      e.stopPropagation();

      const projectId = await addProject();
      await fetchMyProjectsAndUpdateStore();

      navigate(generatePath(ROUTES.DESIGNS, { projectId }));
    },
    [addProject, fetchMyProjectsAndUpdateStore, navigate]
  );

  const active = useMemo(() => {
    const teamPath = generatePath(ROUTES.TEAM_PROJECTS, { teamId: id });
    return location.pathname === teamPath;
  }, [id, location.pathname]);

  return (
    <div
      className={active ? styles.active : styles.inactive}
      onClick={onContainerClick}
    >
      <span>{name}</span>
      <div className={styles.addButton} onClick={onAddProjectClick}>
        {canAddProject && <Add fontSize="inherit" className={styles.addIcon} />}
      </div>
    </div>
  );
};
